import React from 'react';
import { useNavigate } from 'react-router-dom';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';
import { getConsolidatedForecastingUrl, PREDICT_PRODUCT_SLUG, ROUTES } from '@futrli/shared-services';

import { ForecastType as ForecastTypeType } from '../../../dashboard/types';
import { ThreeWayForecastCreatedWizardScreen } from '../create-3-way-forecast-wizard-container/screens/three-way-forecast-created-wizard-screen';
import { ThreeWayForecastCreatingWizardScreen } from '../create-3-way-forecast-wizard-container/screens/three-way-forecast-creating-wizard-screen';
import { ConsolidatedForecastFormWizardScreen } from './screens/consolidated-forecast-form-wizard-screen';
import { trackCreateForecastEvent } from '../../../dashboard/utils';
import { useCreateConsolidatedForecastWizardContext } from '../../contexts/create-consolidated-forecast-wizard-context';

export interface CreateConsolidatedThreeWayForecastContainerProps {
  onClose: () => void;
}

export const CreateConsolidatedThreeWayForecastContainer = ({
  onClose
}: CreateConsolidatedThreeWayForecastContainerProps) => {
  const navigate = useNavigate();

  const { consolidationId, form, view, workspaceId } = useCreateConsolidatedForecastWizardContext();
  const { errorCreating, isLoading, isCreating, newConsolidatedForecastId } = view.state;

  const { getRequestData, validate } = form;

  const error = errorCreating ? true : '';

  const screen = (() => {
    if (isLoading) {
      return 'loading';
    }
    if (isCreating) {
      return 'creating';
    }
    if (newConsolidatedForecastId) {
      return 'created';
    }
    return 'form';
  })();

  const handleCreate = () => {
    if (validate()) {
      view.createConsolidatedForecast(getRequestData());
    }
  };

  const handleView = () => {
    if (newConsolidatedForecastId) {
      trackCreateForecastEvent(ForecastTypeType.SCENARIO);
      const basePath = getConsolidatedForecastingUrl(workspaceId, consolidationId, PREDICT_PRODUCT_SLUG);
      onClose();
      navigate(`${basePath}/${newConsolidatedForecastId}${ROUTES.PREDICTIONS}${ROUTES.SALES}`);
    }
  };

  return (
    <>
      {screen === 'loading' && <LoadingWizardScreen />}
      {screen === 'form' && (
        <ConsolidatedForecastFormWizardScreen error={error} onClose={onClose} onCreate={handleCreate} />
      )}
      {screen === 'creating' && <ThreeWayForecastCreatingWizardScreen />}
      {screen === 'created' && <ThreeWayForecastCreatedWizardScreen onClose={onClose} onView={handleView} />}
    </>
  );
};
